import { bool, contentTable, date, index, text } from "@-/dev.improve.haniverse.lib.database.table";

export const appGraphemeMeaningCardTable = contentTable(
  "app_grapheme_meaning_card",
  {
    /** We should be using this column to join with `actor.user_grapheme_meaning_card` */
    completedAt: date("completed_at"),

    final: bool("final").notNull().default(false),
    gloss: text("gloss"),
    grapheme: text("grapheme").notNull().unique(),
    isDescriptionPremium: bool("is_description_premium").notNull().default(true),
    label: text("label"),
    obsolete: bool("obsolete").notNull().default(false),
  },
  (table) => [index("app_grapheme_meaning_card_grapheme_idx").on(table.grapheme)],
);

export type AppGraphemeMeaningCard = typeof appGraphemeMeaningCardTable.$inferSelect;
